import React from 'react'

function PreviousButton(props) {
    return (
        <>
            <span
                className='sf-arrow-left me-2 cursor position-absolute top-0 start-0 mt-3 ms-3 text-lg'
                onClick={props.previousPage === 'ResetPassword' ? props.showReset : props.showLogin}></span>
        </>
    )
}

export default PreviousButton